import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { useCloseTab } from '../../components/tabs/TabsContext';
import Input from '../../components/Input';
import { onChange } from '../../utils/functions';
import Button from '../../components/Button';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useApiProgress } from '../../hooks/ApiProgress';
import { CURRENCIES, VALIDATION_MESSAGE } from '../../utils/constants';
import Spinner from '../../components/Spinner';
import { CHEQUE_PATH, getChequeById, updateCheque } from '../../api/chequeApi';
import CustomerPicker from '../../components/customer/CustomerPicker';
import useFirstRender from '../../hooks/FirstRender';
import { CUSTOMER_PATH, getPageCustomers } from '../../api/customerApi';
import CurrencyPicker from '../../components/currency/CurrencyPicker';

const ChequeEditPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const isFirstRender = useFirstRender()
    const { id } = useParams();
    const closeTab = useCloseTab()
    const dispatch = useDispatch()
    const [cheque, setCheque] = useState({

    })
    const [customerPage, setCustomerPage] = useState({
        content: []
    });
    const [errors, setErrors] = useState({})
    const pendingApiCall = useApiProgress('put', `${CHEQUE_PATH}`, false)
    const pendingApiCallLoading = useApiProgress('get', `${CHEQUE_PATH}`, false)

    useEffect(() => {
        getChequeById(id).then(res => setCheque(res.data))
    }, [id])

    const [customerQuery, setCustomerQuery] = useState('')
    const [searchTimerCustomer, setSearchTimerCustomer] = useState();
    const pendingApiCallCustomer = useApiProgress('get', `${CUSTOMER_PATH}/page`, false)
    const [customer, setCustomer] = useState()
    const searchingCustomer = async (params) => {
        if (searchTimerCustomer) clearTimeout(searchTimerCustomer);
        let timer = setTimeout(() => {
            getPageCustomers(params)
                .then(res => {
                    setCustomerPage(res.data)
                })
        }, 500);
        setSearchTimerCustomer(timer);
    }
    const onClickLoadMoreCustomer = () => {
        if (!customerPage.last) {
            loadCustomers({ search: customerQuery, lastId: customerPage.content[customerPage.content.length - 1]?.id })
        }
    }
    const loadCustomers = (params) => {
        !pendingApiCallCustomer &&
            getPageCustomers(params)
                .then(res => {
                    setCustomerPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }
    useEffect(() => {
        !isFirstRender && searchingCustomer({ search: customerQuery })
    }, [customerQuery])

    const onClickSubmit = () => {
        updateCheque(id, cheque).then(res => {
            closeTab()
            toast.success('Çek güncellendi')
        }).catch(err => {
            toast.error(VALIDATION_MESSAGE)
            setErrors(err.response.data.validationErrors)
        })
    }

    useEffect(() => {
        loadCustomers({ size: 20 })
    }, [])

    if (pendingApiCallLoading) return (
        <div className='flex justify-center'>
            <Spinner />
        </div>
    )

    return (
        <div className='grid grid-cols-1 place-items-center'>
            <div className='col-span-6 w-96'>
                <label className='text-xl mb-5 block'>Çek Düzenle</label>
                <CustomerPicker
                    label='Müşteri'
                    pendingApiCall={pendingApiCallCustomer}
                    state={customer}
                    setState={(value) => setCustomer(value)}
                    query={customerQuery}
                    setQuery={setCustomerQuery}
                    //error={errors.customerId}
                    page={customerPage}
                    setErrors={() => setErrors(prevState => ({ ...prevState, customerId: undefined }))}
                    onClickClear={() => setCustomer()}
                    onClickLoadMore={() => onClickLoadMoreCustomer()}
                />
                <Input
                    name='owner'
                    label='Çek Sahibi'
                    type='text'
                    placeholder='Çek sahibini girin...'
                    value={cheque.owner}
                    error={errors?.owner}
                    onChange={e => onChange(e, setCheque, setErrors)}
                />
                <CurrencyPicker
                    label="Kur"
                    value={cheque.currency}
                    onChange={(currency) => {
                        setCheque(prevState => ({ ...prevState, currency }))
                        setErrors(prevState => ({ ...prevState, currency: undefined }))
                    }}
                    text={(cheque.currency) || 'Kur seçin'}
                    items={CURRENCIES}
                    error={errors?.currency}
                />
                <Input
                    name='amount'
                    label='Tutar'
                    type='number'
                    value={cheque.amount}
                    error={errors?.amount}
                    placeholder='Tutar girin...'
                    onChange={e => onChange(e, setCheque, setErrors)}
                />
                <Input
                    name='deadline'
                    label='Son Tarih'
                    type='date'
                    value={cheque.deadline}
                    error={errors?.deadline}
                    onChange={e => onChange(e, setCheque, setErrors)}
                />
                <Input
                    name='serialNumber'
                    label='Çek Numarası'
                    type='text'
                    value={cheque.serialNumber}
                    error={errors?.serialNumber}
                    placeholder='Çek numarası girin...'
                    onChange={e => onChange(e, setCheque, setErrors)}
                />
                <Input
                    name='bank'
                    label='Banka'
                    type='text'
                    value={cheque.bank}
                    error={errors?.bank}
                    placeholder='Banka adı girin...'
                    onChange={e => onChange(e, setCheque, setErrors)}
                />
                <Input
                    className='mb-3'
                    name='branch'
                    label='Şube'
                    type='text'
                    value={cheque.branch}
                    error={errors?.branch}
                    placeholder='Şube adı girin...'
                    onChange={e => onChange(e, setCheque, setErrors)}
                />
                <Button
                    text='Kaydet'
                    variant='green'
                    onClick={onClickSubmit}
                />
            </div>
        </div>
    )
}

export default ChequeEditPage